import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { QuoteModel } from '../../Models/Models/Processes/Quote/QuoteModel';
import { ServiceValidationError } from '../../Core/DataTypes/ServiceValidation/ServiceValidationError';

declare var IS_RUNNING_IN_APP_POOL;

export class QuoteInstructionClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(instructionId: number, product: string): Promise<QuoteModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Quote/QuoteInstruction/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { instructionId: instructionId, product: product }

    return AjaxWrapper.get<QuoteModel, any>(url, data);
  }
  public post(quoteModel: QuoteModel): Promise<QuoteModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Quote/QuoteInstruction/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { quoteModel: quoteModel }

    return AjaxWrapper.post<QuoteModel, any>(url, data);
  }
  public delete(instructionId: number): Promise<Array<ServiceValidationError>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Quote/QuoteInstruction/Delete';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { instructionId: instructionId }

    return AjaxWrapper.post<Array<ServiceValidationError>, any>(url, data);
  }
  public put(instructionId: number): Promise<Array<ServiceValidationError>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Quote/QuoteInstruction/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { instructionId: instructionId }

    return AjaxWrapper.post<Array<ServiceValidationError>, any>(url, data);
  }
}

